export default __webpack_public_path__ + "static/media/blog-bnr.8d7315be.png";